module.exports = __webpack_public_path__ + "static/media/name-icon.626c0bdb.svg";